import script from "./blog-posts-table-view.vue?vue&type=script&setup=true&lang=js"
export * from "./blog-posts-table-view.vue?vue&type=script&setup=true&lang=js"

import "./blog-posts-table-view.vue?vue&type=style&index=0&id=6a67ec4c&scoped=true&lang=scss"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a67ec4c"]])

export default __exports__